import { atom } from 'recoil';

export const ratingModalAtom = atom({
  key: 'ratingModal',
  default: false,
});
